export default __webpack_public_path__ + "static/media/activity-modeling.74845f50.png";